export default "__VITE_ASSET__Blp7QLWG__"